var PasswordRecoveryModel = Backbone.Epoxy.Model.extend({

  initialize: function() {
    Backbone.Validation.bind(this, {liveValidation: true});
  },

  computeds: {
    hasErrorMessage: {
      get: function() {
        return this.get('errorMessage') !== '';
      }
    },
    hasSuccessMessage: {
      get: function() {
        return this.get('successMessage') !== '';
      }
    }
  },

  defaults: {
    token: '',
    password: '',
    passwordConfirmation : '',
    errorMessage: '',
    successMessage: ''
  },

  validation: {
    password: [
      {
        fn: function(){
          const vRes = global.bookedby.helpers.passwordValidate(this.get('password'));
          return vRes.isValid ? null : vRes.errorMsg;
        }
      }
    ],
    passwordConfirmation: [
      {
        //Future injection point to ensure other password characteristics (minimun complexity, required character classes, etc.)
        fn: function(value) {
          const vRes = global.bookedby.helpers.confirmPasswordValidate(this.get('passwordConfirmation'), this.get('password'));
          return vRes.isValid ? null : vRes.errorMsg;
        }
      }
    ]
  }

});

var PasswordRecoveryView = Backbone.Epoxy.View.extend({

  template: 'password-recovery.layout',

  events: {
    'click #recoverPasswordSubmitBtn' : 'submit'
  },

  submit : function () {

    this.model.set('errorMessage', '');
    this.model.set('successMessage', '');

    if(this.model.isValid(true)) {
      global.bookedby.helpers.confirmLogoutEvent(false);
      bookedby.app.logOut();

      $.ajax({
        url: bookedby.routes.AUTHENTICATION.DO_RECOVER_PASSWORD,
        contentType: 'application/json',
        method: 'POST',
        data: JSON.stringify({
          section: bookedby.app.section,
          token: this.model.get('token'),
          password: this.model.get('password'),
          passwordConfirmation: this.model.get('passwordConfirmation')
        }),
        dataType: 'json',
        success: _.bind(function(data) {

          if (data.success) {

            if (!data.loggedIn) {
              if (data.email) {
                bookedby.app.getCurrentClient().set('email', data.email);
              }
              bookedby.app.navigateTo('login', { message: 'Your password was changed', recover: true });
            } else {
              bookedby.app.onLoginResponse(data.loggedInData);

              var options = {
                message: 'Your password was changed',
                confirmLabel: 'Go To Profile',
                showCancelLabel: false
              };

              bookedby.app.confirmForm.show(_.bind(function(){
                bookedby.app.navigateTo('profile', {}, 'password-recovery', {});
              }, this), _.noop, options);
            }

          } else if (data.userError) {
            this.model.set('errorMessage', data.error);
          } else {
            bookedby.app.logAPIError(data.error);
          }
        }, this),
        error: _.bind(function(jqXHR, textStatus, textError) {
          bookedby.app.logAPIError(textError);
        }, this)
      });
    }
  },

  setData: function (newData) {
    this.model.set('token', newData.token);
  },

  initialize: function() {
    this.model = new PasswordRecoveryModel();
  },

  beforeRender: function() {
    if (this.isLoading) {
      bookedby.app.startLoading();
      return false;
    }
    return true;
  },

  afterRender: function() {
    if (!this.isLoading) {
      bookedby.app.finishLoading();
    }
    this.applyBindings();
  },

  cleanup: function() {
    this.removeBindings();
  }


});

module.exports = PasswordRecoveryView;